import { gsap } from 'gsap'
import { deepMerge, getCubicCurve } from 'js/utils/Utils'

import Common from 'js/_core/Common'
import FadeInViewItem from 'js/modules/_base/effects/FadeInViewItem'

const defaults = {
  instanceName: 'titleFadeAInViewItem',
  $names: {
    trigger: '[data-anim="line-a-iv"]',
    maskIn: '.mask_in',
  },
}

export default class LineAInViewItem extends FadeInViewItem {
  constructor(options = {}) {
    super()
    this._iom = Common.iom3
    deepMerge(this, defaults, options)
  }

  init() {
    super.init()
  }

  destroy() {
    super.destroy()
  }

  setInitialStyle($el, index) {
    gsap.set($el, {
      opacity: 0,
    })
  }

  async animateIn($el, index) {
    requestAnimationFrame(() => {
      const $maskIn = $el.querySelectorAll(this.$names.maskIn)

      gsap.set($el, {
        opacity: 1,
      })

      if ($maskIn) {
        gsap.fromTo(
          $maskIn,
          {
            x: '-100%',
            rotate: 0.001,
            force3D: false,
          },
          {
            x: '0%',
            force3D: false,
            duration: 1,
            ease: getCubicCurve(0.6, 0.3, 0, 1),
          }
        )
      }
    })
  }
}